<template>
  <el-dialog :visible.sync="visible">
    <h3 class="title">医学检测服务同意书</h3>
    <p>尊敬的客户：</p>
    <p>您好！为了确保检验的顺利进行并充分保障您的权益，在您参加本次检测前，您需要清楚了解并同意以下相关内容：</p>
    <p class="title">1、检测目的</p>
    <p>我方将根据已开设的检测项目进行检测服务，所开设内容均按照国家法律规定和行业监管部门要求操作执行。通过本次检测，可以对您当次提供的样本进行专业的检测分析并提供专业的检测报告。</p>
    <p class="title">2、检测约束</p>
    <p>我方将对自采、上门或委托第三方有采集资格的机构进行样本采集，并注明采集时间。我方会在检测项目要求的规定时间内，按规定方式对所采集的样本进行处理和存储。如因用户自行采集或处理存储不当，造成的样本不符合检测要求，我方不承担后果。</p>
    <p>用户方须确保向我方提供完整的样本检测申请信息，包括患者基本信息、检测项目信息、采集时间等，以便我方进行综合检测分析。</p>
    <p>我方将按照国家及行业标准对样本进行保存，由于样本本身特性不能达到此保存期限，或按照此期限进行样本保存无意义时，可对保存期限另行约定。</p>
    <p>另外，出于医学技术原因，检测不能保证100%的检出率，如有可疑异常情况，请前往医疗机构做进一步检查和治疗。</p>
    <p class="title">3、用户方权利义务</p>
    <p>3.1 用户方享有对所购买的检测项目进行采样和报告查询权利。</p>
    <p>3.2 用户方可以通过平台软件进行下单和报告查询等服务。</p>
    <p>3.3 用户方须按照所检测项目，如实填写项目相关的检测调查，否则由此产生的后果，我方概不负责。</p>
    <p>3.4 用户方须保障采集的样本按前置要求采集，如因不符合采样要求，对采样的样本检测结果准确性产生影响，我方概不负责。</p>
    <p class="title">4、我方权利义务</p>
    <p>4.1 我方保证自身的检测能力和资源能够满足用户方的委托检测要求，包括实验室人员的技能和专业知识、检测方法等。</p>
    <p>4.2 如样本不符合要求，我方有权退单，如用户方坚持检测，我方对检测结果不承担责任。</p>
    <p>4.3 如我方对检测项目、收费标准、检测报告交付时间等进行变更，有义务对正在检测的患者进行通知。</p>
    <p>4.4 我方保证在未经用户同意的情况下，不以商业为目的将检测相关信息提供给第三方公司使用。</p>
    <p>4.5 软件系统因客观存在断电、断网、中病毒等风险，我们将尽最大努力采取多种措施保障平台稳定运行，如因客观意外风险导致的损失，我方不承担责任。</p>
    <p class="title">5、自愿参加声明</p>
    <p>本次检查只是对本次样本进行科学的常规检测，不是最后的诊断结论，检查结果也会随着您个人身体情况的改变而发生变化，请结合您的治疗医生诊断进行最后的诊断和治疗。</p>
    <p>检测前请详细阅读本声明和具体相关检测项目说明，严格按照说明进行操作。如因本次检测产生争议，双方应友好协商解决，如协商不成，有权向我方所在地人民法院提起诉讼。</p>
    <p>如您勾选条款并进行后续购买等操作，表示您已认真阅读并自愿同意本检测服务同意书中的内容。</p>
    <p>祝您健康！</p>
  </el-dialog>
</template>

<script>
  import axios from 'axios'
  import { getCookie } from "../util/util"

  export default {
    name: "rules-detail",
    data() {
      return {
        visible: false,
      }
    },
    methods: {
      init () {
        this.visible = true
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-dialog__body{
    padding: 0 20px 30px 20px;
  }
  h3.title{
    text-align: center;
    padding: 10px 0 20px 0;
  }
  .title{
    font-size: 18px;
    font-weight: bold;

  }
  p{
    line-height: 30px;
    text-indent:2em
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .el-dialog {
      width: 98%!important;
    }

    /deep/ .el-dialog__body {
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rules-detail.vue